import { render, staticRenderFns } from "./PushoverIcon.vue?vue&type=template&id=01e57c42&scoped=true"
import script from "./PushoverIcon.vue?vue&type=script&lang=js"
export * from "./PushoverIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01e57c42",
  null
  
)

export default component.exports